import { ACTION } from './interfaces';
import type {
  FreemiumAction,
  UpdateCanAccessTofPremiumAction,
  UpdateDataAction,
  UpdatePremiumFiltersAction,
} from './interfaces';

const actions = {
  updatePremiumFilters({
    reducerDispatch,
    filters,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    filters: UpdatePremiumFiltersAction['payload']['filters'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_FILTERS,
      payload: {
        filters,
      },
    });
  },
  updateData({
    reducerDispatch,
    data,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    data: UpdateDataAction['payload']['data'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_DATA,
      payload: {
        data,
      },
    });
  },
  updateCanAccessTopOfFunnelPremium({
    reducerDispatch,
    canAccessTopOfFunnelPremium,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    canAccessTopOfFunnelPremium: UpdateCanAccessTofPremiumAction['payload']['canAccessTopOfFunnelPremium'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM,
      payload: {
        canAccessTopOfFunnelPremium,
      },
    });
  },
};

export default actions;
